// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "services/api";

export const getReferralCode = createAsyncThunk("wallet/getReferralCode", async (address: string): Promise<string> => {
  const response = await api().get(`mainnet/membership/referral-code/${address}`);
  if (response.status === 200) {
    return response.data;
  }
  return "";
});
